import { Callback, CallbackType, ExtraAction, apiCall, createApiRequestPayload } from '..';
import { Gallery, GalleryRequest } from '../../../../model/Carrusel';

const BASE_PATH = `/api/crm/galleries`;

export const findGalleriesByQuery = (
  apiQuery: Map<string, string>,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const urlPathParameters = Array.from(apiQuery.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  const apiPath = `${BASE_PATH}?${urlPathParameters}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
  );
  return apiCall(requestPayload);
};

export const galleryUpdate = (
  gallery: GalleryRequest,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const apiPath = `${BASE_PATH}/${gallery.id}`;
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'PUT',
    gallery,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const galleryDelete = (
  gallery: Gallery,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const apiPath = `${BASE_PATH}/${gallery.id}`;
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'DELETE',
    gallery,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const galleryCreate = (
  gallery: GalleryRequest,
  successActionName: string,
  callbacks?: Array<Callback>,
  extraActions?: Array<ExtraAction>,
) => {
  const apiPath = BASE_PATH;
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'POST',
    gallery,
    undefined,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const findPhotosByQuery = (
  galleryId: number,
  apiQuery: Map<string, string>,
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const urlPathParameters = Array.from(apiQuery.entries())
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  const apiPath = `${BASE_PATH}/${galleryId}/photos?${urlPathParameters}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
  );
  return apiCall(requestPayload);
};

export const findPhotosByIds = (
  ids: number[],
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('find photos by query success'),
      full: false,
    },
  ],
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const apiPath = `${BASE_PATH}/photos?ids=${ids.join(',')}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'GET',
    undefined,
    customErrorsMap,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};

export const photoDelete = (
  galleryId: number,
  id: number,
  successActionName: string,
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      function: () => console.log('delete photo by id success'),
      full: false,
    },
  ],
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
) => {
  const apiPath = `${BASE_PATH}/${galleryId}/photos/${id}`;
  console.log(`apiPath`, apiPath);
  const requestPayload = createApiRequestPayload(
    apiPath,
    successActionName,
    'DELETE',
    undefined,
    customErrorsMap,
    extraActions,
    callbacks,
  );
  return apiCall(requestPayload);
};
